'use client'
import React from 'react'
import CTHeaderContainer from '../variants/cleartrip'
import FlyinHeaderContainer from '../variants/flyin'

interface HeaderContainerProps {
    hideSignIn?: boolean
    domainCountry?: string
    showVisa?: boolean
    /** Active vertical resolved server-side (from the request path) for nav highlighting. */
    activeVertical?: string | null
}

const HeaderContainer: React.FC<HeaderContainerProps> = ({
    hideSignIn = false,
    domainCountry,
    showVisa = false,
    activeVertical = null
}) => {
    const showFlyinHeader = domainCountry === 'FEG' || domainCountry === 'FSA' || domainCountry === 'FAE'

    return showFlyinHeader ? (
        <FlyinHeaderContainer hideSignIn={hideSignIn} showVisa={showVisa} activeVertical={activeVertical} />
    ) : (
        <CTHeaderContainer hideSignIn={hideSignIn} showVisa={showVisa} activeVertical={activeVertical} />
    )
}

export { HeaderContainer }
export default HeaderContainer
